// extracted by mini-css-extract-plugin
export default {"about":"About_about__5Aa7S","aboutSection":"About_aboutSection__4wN1J"};